export default __webpack_public_path__ + "static/media/ic_iceland.962b31b1.svg";